import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';
import { AppConstants } from '../shared/app.constants';
var FreelancersService = /** @class */ (function () {
    function FreelancersService(http, auth, appConstants) {
        this.http = http;
        this.auth = auth;
        this.appConstants = appConstants;
    }
    FreelancersService.prototype.getAllFreelancers = function () {
        var url = environment.apiBase + 'freelancers';
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    FreelancersService.prototype.getFreelancer = function (id) {
        var url = environment.apiBase + 'freelancers/' + id;
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    FreelancersService.prototype.uploadCoverImageToS3 = function (body) {
        var url = environment.apiBase + 's3/sign';
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.post(url, body, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    FreelancersService.prototype.registerFreelancer = function (body) {
        var url = environment.apiBase + 'register';
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.post(url, body, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    FreelancersService.prototype.updateFreelancer = function (body) {
        var url = environment.apiBase + 'users/' + body.id;
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.put(url, body, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    FreelancersService.prototype.deleteFreelancer = function (freelancerId) {
        var url = environment.apiBase + ("users/" + freelancerId);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.delete(url, { headers: headers }).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    return FreelancersService;
}());
export { FreelancersService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/freelancers/freelancers.service.ts.pre-build-optimizer.js